import React from 'react'

interface NavbarButtonInput {
  text: string
  margin: string
  icon: React.ReactNode // svg
  closeSidebar: () => void
  isSelected: boolean
}

const NavbarButton: React.FC<NavbarButtonInput> = ({ text, margin, icon, closeSidebar, isSelected }) => {

  return (
    <button onClick={closeSidebar} className={`flex flex-row justify-start md:justify-center items-center p-5 md:p-0 text-sm md:text-base font-medium ${margin} ${isSelected ? 'selected bg-cents-purple text-cents-white' : 'bg-cents-grey md:bg-cents-white text-cents-black hover:bg-cents-purple-lighter'} active:bg-cents-purple active:text-cents-white w-full h-12 md:h-14 rounded-2xl`}>
      <div className="mr-5 md:mr-3">
        {icon}
      </div>
      {text}
    </button>
  )
}

export default NavbarButton